import React, { useCallback } from "react";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import { useHistory, useLocation } from "react-router-dom";

import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Button from "../../components/CustomButtons/Button.js";
import themeStyle from "../../assets/jss/eclipse/components/themeStyle.js";
import { primaryColor, cardTextColor, cardBackgroundColor, primaryIconColor } from "../../style.scss"
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import cardPlaceHolder from '../../assets/img/master_card.svg'
import Dialog from '@material-ui/core/Dialog';
import { ReactComponent as SuccessCardIcon } from "../../assets/img/icon_add_a_card_success.svg"
import { DCustomerManagementApi } from "eclipse-react-sdk/services";
import AlertNotification from "../../components/Snackbar/AlertNotification.js";
import { SpinnerComponent } from "react-element-spinner";
import { grayColor } from "../../assets/jss/eclipse.js";
import { loginToApp } from "../../redux-services/actions/actions.js";
import { CardStatus } from "../../eclipse-react-sdk/services/models";


const useStyles = makeStyles(themeStyle);

export function ManageLinkedCard(props) {
  const [linkedBankCards, setLinkedBankCards] = React.useState([]);
  const [cardOnFileId, setCardOnFileId] = React.useState(null);
  const pageState = useLocation().state;
  const fromScreen = pageState?.fromScreen;

  const [openConfirmDialog, setOpen] = React.useState(false);
  const [openSuccessDialog, setOpenSuccess] = React.useState(false);
  const [isGetLinkBankCard, setGetLinkBankCard] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);

  const history = useHistory();
  const classes = useStyles();

  const [alertData, setAlert] = React.useState(null);

  const showAlert = (alertDisplay, alertType, message) => {
    setAlert({ isAlertDisplay: alertDisplay, alertType: alertType, alertMessage: message })
    setTimeout(() => {
      setAlert(null);
    }, 3000);
  }

  const redirectToErrorScreen = useCallback((fromScreen, toScreen) => {
    history.push({
      pathname: toScreen,
      state: { fromScreen: fromScreen }
    });
  }, [history]);

  const linkCard = () => {
    history.push({
      pathname: '/pages/card-on-file',
      state: { ...pageState }
    });
  }

  const backToViaCard = () => {
    if (fromScreen === 'AIRTIMEDATA' || fromScreen === 'BUYAIRTIMEDATA' || fromScreen === 'BUYELECTRICITY') {
      history.push({
        pathname: '/pages/vas-buy-airtime-data',
        state: { ...pageState }
      });
    } else if (fromScreen === 'COLLECTIONS') {
      history.push({
        pathname: '/pages/vas-buy-kganya-products',
        state: { ...pageState }
      });
    } else if (fromScreen === 'PAYBILL') {
      history.push({
        pathname: '/pages/vas-pay-bill',
        state: { ...pageState }
      });
    } else if (fromScreen === 'QRSCAN') {
      history.push({
        pathname: '/pages/pay-amount',
        state: { ...pageState }
      });
    } else if (fromScreen === 'TOPUP') {
      history.push({
        pathname: '/pages/topup',
        state: { ...pageState }
      });
    } else if(fromScreen ==="PAY-PAYSHAP-AMOUNT"){
      history.push({
        pathname: '/pages/topup',
        state: { ...pageState }
      });
    }
    else {
      backToHome();
    }
  }

  const backToHome = useCallback(() => {
    const appData = {
      ...props?.appData,
      isRefresh: true
    }
    props.manageLinkedCardHandler(appData);
    history.push({
      pathname: '/pages/dashboard'
    });
  },[history, props])

  React.useEffect(() => {
    return () => {
      window.onpopstate = () => {
        backToHome();
      }
    };
  }, [backToHome])

  const goForDelete = (data) => {
    setCardOnFileId(data)
    setOpen(true);
  }

  const closeDialog = () => {
    setOpen(false)
  };


  const bankCardNoLinked = useCallback(() => {
    history.replace({
      pathname: '/pages/no-card-linked',
      state: { ...pageState }
    });
  }, [history, pageState]);


  const getLinkedBankCards = useCallback(() => {
    setLoading(true);
    const linkedBankCardsAPI = new DCustomerManagementApi();
    linkedBankCardsAPI.tenantsTenantIdCustomersCustomerIdCardsOnFileGet(props?.appData?.auth?.tenantId, props?.appData?.customer?.customerId).then((linkedBankCardsAPIResponse) => {
      if (linkedBankCardsAPIResponse.data && linkedBankCardsAPIResponse.data.length > 0) {
        linkedBankCardsAPIResponse.data = linkedBankCardsAPIResponse.data.filter((card=>card.status ===CardStatus?.ACTIVE))
        if(linkedBankCardsAPIResponse?.data?.length>0){
          setLinkedBankCards(linkedBankCardsAPIResponse.data);
          setGetLinkBankCard(true);
        }else{
          bankCardNoLinked();
        }
        
      } else {
        setLoading(false);
        bankCardNoLinked();
      }
      setLoading(false);
    }).catch((error) => {
      setLoading(false);
      if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
        showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
      } else {
        redirectToErrorScreen('/pages/dashboard', '/pages/error');
      }
    });
  }, [props, redirectToErrorScreen, bankCardNoLinked]);

  React.useEffect(() => {
    if (linkedBankCards.length < 1 && !isGetLinkBankCard) {
      getLinkedBankCards();
    }
  }, [linkedBankCards, getLinkedBankCards, isGetLinkBankCard]);

  const deleteLinkedBankCards = useCallback(() => {
    const deleteLinkedBankCardsAPI = new DCustomerManagementApi();
    deleteLinkedBankCardsAPI.tenantsTenantIdCustomersCustomerIdCardsOnFileCardOnFileIdDelete(props?.appData?.auth?.tenantId, props?.appData?.customer?.customerId, cardOnFileId).then((deleteLinkedBankCardsAPIResponse) => {
      if (deleteLinkedBankCardsAPIResponse) {
        closeDialog();
        setOpenSuccess(true)
        getLinkedBankCards()
      } else {
        closeDialog();
      }
    }).catch((error) => {
      if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
        showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
      } else {
        redirectToErrorScreen('/pages/dashboard', '/pages/error');
      }
    });
  }, [props, cardOnFileId, redirectToErrorScreen, getLinkedBankCards]);

  const successDelete = () => {
    setOpenSuccess(false)
  };


  return (
    <div>
      <SpinnerComponent loading={isLoading} position="global" color={primaryColor} />
      <Dialog open={openConfirmDialog}>
        <div style={{ float: 'left', width: '100%', padding: '20px', boxSizing: 'border-box' }}>
          <p className={classes.regularFontSize + ' ' + classes.textLeft + ' m-t-0'}><b>Are you sure you want to delete your linked bank card?</b></p>
          <p className={classes.regularFontSize + ' ' + classes.textLeft + ' m-t-0'}>Your card will be permanently deleted, but you can link it again at any time.</p>
          <span style={{ display: 'flex', justifyContent: 'flex-end', margin: '20px 0 0 0' }}>
            <strong className={classes.linkColor} onClick={closeDialog}>Cancel</strong> &nbsp;&nbsp;
            <strong className={classes.linkColor} onClick={deleteLinkedBankCards}>Delete</strong>
          </span>
        </div>
      </Dialog>
      <Dialog open={openSuccessDialog}>
        <div style={{ float: 'left', width: '100%', padding: '20px', textAlign: 'center', boxSizing: 'border-box' }}>
          <SuccessCardIcon stroke={primaryIconColor} fill={primaryIconColor} />
          <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}><b>Your card was successfully deleted.</b></p>
          <span style={{ display: 'flex', justifyContent: 'flex-end', margin: '20px 0 0 0' }}>
            <strong className={classes.linkColor} onClick={successDelete}>Done</strong>
          </span>
        </div>
      </Dialog>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} style={{ display: 'flex' }}>
              <ArrowBackIosIcon className={classes.linkColor} onClick={backToViaCard}/>
              <span className={classes.title}>My linked cards</span>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <p className={classes.regularFontSize + ' ' + classes.textLeft + ' m-b-0'}><b>Manage your linked cards</b></p>
              <ul className='linked-card-list' style={{ padding: '0', marginBottom: '0', listStyle: 'none', height: 'calc(100vh - 320px)', overflow: 'auto' }}>
                {linkedBankCards && linkedBankCards.length > 0 ? linkedBankCards.map((card) => {
                  return (<li style={{ background: cardBackgroundColor, color: cardTextColor, display: 'flex', alignItems: 'center', padding: '0.75em', boxShadow: '0px 1px 5px 1px ' + grayColor[1], margin: '0.25em 0.25em 1em', borderRadius: '5px' }} key={card?.cardOnFileId}>
                    <span><img src={cardPlaceHolder} alt="" /></span>
                    <div className="content">
                      <p className=' m-b-0 m-t-0'>{card?.alias}</p>
                      <small>{'**** **** **** ' + card?.last4Digits}</small>
                    </div>
                    { props?.appData?.physicalCards?.find(e => e.pan.slice(-4) === card?.last4Digits) ?
                      null :
                    <strong style={{ marginLeft: 'auto' }} onClick={goForDelete.bind(null, card.cardOnFileId)}>
                      <CancelOutlinedIcon className={classes.linkColor} />
                    </strong>
                    }
                  </li>)
                }) : null
                }
              </ul>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <Button className={classes.buttonRadius} size="lg" block color="primary" type="button" onClick={linkCard}>Add a card</Button>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      {alertData?.isAlertDisplay ? <AlertNotification alertData={alertData} /> : null}
    </div>
  )
}


const mapStateToProps = state => ({
  appData: state.applicationData.appData
})

const mapDispatchToProps = dispatch => ({
  manageLinkedCardHandler: data => dispatch(loginToApp(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageLinkedCard)